<script>
import {defineComponent} from "vue";
import headtip from "@/views/headTip.vue";
import consultTip from "@/components/consultTip.vue";

export default defineComponent({
  components: {consultTip, headtip},
  data(){
    return{
      dialogVisible: false,
      title: 'GPT Assistants',
    }

  },
  methods:{
    tohome(){
      window.open("/")
    },
    clickConsult(item) {

      console.log(item)
      this.title = item
      this.dialogVisible = true;
      sessionStorage.setItem('title', item)
    },
    hideDialog() {
      localStorage.setItem("skip", 0)
      this.dialogVisible = false;
    },

  }
})
</script>

<template>
<div class="assistantsContainer" style="z-index: 999">
<!--  <div class="topback" ref="topback"-->
<!--       :style="{ height: '6vh', backgroundColor: scrollback ? 'rgb(245 244 246)' : 'rgb(245 244 246)' ,position:'fixed',top:'0'}">-->
<!--    <headtip :changeVisable="changeVisable" @showDialog="showPartner"></headtip>-->
<!--  </div>-->
<!--  <img @click="()=>{$parent.visible=false}" style="height:2vw;width:2vw;position:fixed;right: 2vw;top: 2vw" src="@/assets/error.png">-->
  <div class="title1">Open Claw</div>
  <!-- <div class="title2">让您一键即可访问主流人工智能工具模型</div>
  <div style="width: 100%;height: 2vw;display: flex;margin-top: 2vh">
    <div class="title2" style="display: flex;align-items: center;margin: auto">
      <img src="@/assets/kefu3.png" style="height: 2vw;width: 2vw">
      <span style="color:#f97420;">若想定制化的使用培训与开发,</span> -->
<!--      <div style="background-color: #1b1e76;color: white;padding: 0.1vh 0.5vw;border-radius: 9px;cursor: pointer;font-weight: bolder;" @click="clickConsult('Office GPTs')" >联系我们</div>-->
      <!-- <div style="background-color: #1b1e76;color: white;padding: 0.1vh 0.5vw;border-radius: 9px;cursor: pointer;font-weight: bolder;" @click="()=>{$parent.$parent.naviclickConsult('定制化AI工具')}" >联系我们</div>
    </div>
  </div> -->
  <div class="assistants" style="display: grid;grid-template-columns: minmax(0,1fr) minmax(0,1fr);padding: 0 4vw;position: relative">
    <a href="https://console.volcengine.com/ark/claw " target="_blank">
      <div class="assistant" >
        <img  src="@/assets/openclaw/zijie.svg">
        <div class="contentDesign">
          <div class="t1">字节ArkClaw</div>
          <div class="t2">
            深度适配飞书生态，低代码一键部署，让你的 AI Agent 快速落地，高效赋能业务协作！  
          </div>
        </div>
      </div>
    </a>
    <a href="https://www.codebuddy.cn/work" target="_blank">
      <div class="assistant">
        <img  src="@/assets/openclaw/tengxun.svg">
        <div class="contentDesign">
          <div class="t1">腾讯 WorkBuddy</div>
          <div class="t2">
            深度集成企微 / QQ 能力，一键打通团队沟通与任务流，全面提升协作效率，办公更省心！
          </div>
        </div>
      </div>
    </a>
    <a href="https://activity.huaweicloud.com/openclaw.html" target="_blank">
      <div class="assistant">
      <img  src="@/assets/openclaw/huawei.svg">
      <div class="contentDesign">
        <div class="t1">华为OpenClaw</div>
        <div class="t2">
          华为云一键部署，满足高安全合规要求，为企业级 AI 应用提供稳定可靠的技术底座！
        </div>
      </div>
    </div>
    </a>
    <a href="https://www.aliyun.com/activity/ecs/clawdbot" target="_blank">
      <div class="assistant">
      <img  src="@/assets/openclaw/ali.svg">
      <div class="contentDesign">
        <div class="t1">阿里OpenClaw</div>
        <div class="t2">
          集成 AgentBay 企业级托管能力，完美适配云原生场景，让 AI 服务弹性扩容、高效运行！
        </div>
      </div>
    </div>
    </a>
    <a href="https://console.bce.baidu.com/qianfan/studio/openclaw" target="_blank">
      <div class="assistant">
        <img  src="@/assets/openclaw/baidu.svg">
        <div class="contentDesign">
          <div class="t1">百度OpenClaw</div>
          <div class="t2">
            3-5 分钟快速体验，支持 App 搜索框直接调用，开箱即用，轻松构建行业 AI 应用！
          </div>
        </div>
      </div>
    </a>
    <a href="https://www.kimi.com/bot" target="_blank">
      <div class="assistant">
        <img  src="@/assets/openclaw/kimi.svg">
        <div class="contentDesign">
          <div class="t1">Kimi Claw</div>
          <div class="t2">
            集成 Kimi 大模型，超强文档问答，一键接入生态，赋能知识管理与智能办公！
          </div>
        </div>
      </div>
    </a>
<!--    <img @click="tohome" style="height: 3vw;width: 3vw;position: absolute;top: -10vh;left: 16vw;cursor: pointer" src="@/assets/back1.png">-->
  </div>
  <consultTip
      :thisTitle="title"
      :dialogVisible="dialogVisible"
      @hideDialog="hideDialog"
  ></consultTip>
</div>
</template>

<style scoped lang="scss">
.assistantsContainer{
  width: 100%;
  background-color: rgba(237, 242, 253, 0.99);
  .topback {
    position: fixed;
    z-index: 9;
    width: 100vw;
    padding: 0 0 0 2.86077411900635vw;
  }
  .title1{
    font-size: 2vw;
    margin: auto;
    padding: 2vh 0;
    text-align: center;
    font-weight: bolder;
  }
  .title2{
    font-size: 1.1vw;
    text-align: center;

  }
  .assistant{
    margin: 2vh;
    //padding: 4vh 3vw 4vh 2vw;
    padding: 2vh 3vw 0vh 2vw;
    display: flex;
    //border: 1px solid gray;
    background-color: white;
    border-radius: 9px;
    img{
      width: 3vw;
      height: 3vw;
    }
    .contentDesign{
      margin-left: 1vw;
      .t1{
        text-align: left;
        font-size: 1.2vw;
        font-weight: bolder;
      }
      .t2{
        text-align: left;
        margin-top: 1vh;
        font-size: 0.8vw;
        height: 5.5vw;
        line-height: 1.5;
      }
    }
  }
}

</style>
